import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ dealership, isOpen, onConfirm, onCancel }) => {
  if (!isOpen || !dealership) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 animate-fade-in">
      <div className="bg-card rounded-lg shadow-modal max-w-md w-full">
        <div className="p-6 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground">
                Partner löschen?
              </h2>
              <p className="text-sm text-muted-foreground mt-1">
                Diese Aktion kann nicht rückgängig gemacht werden.
              </p>
            </div>
          </div>

          <div className="p-4 bg-muted/50 rounded-lg border border-border">
            <p className="text-sm text-foreground mb-2">
              <span className="font-medium">Partner:</span> {dealership?.name}
            </p>
            <p className="text-sm text-foreground mb-2">
              <span className="font-medium">Standort:</span> {dealership?.location}
            </p>
            <p className="text-sm text-foreground">
              <span className="font-medium">URL:</span> gridbalance.de/{dealership?.generatedUrl}
            </p>
          </div>

          <div className="p-4 bg-warning/10 rounded-lg border border-warning/20">
            <div className="flex items-start gap-2">
              <Icon name="AlertCircle" size={18} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <p className="text-sm text-warning">
                Alle zugehörigen Landing Pages, QR Codes und Gutscheincheck-Portale werden ebenfalls gelöscht.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button variant="outline" onClick={onCancel} iconName="">
            Abbrechen
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            iconName="Trash2"
            iconPosition="left"
          >
            Löschen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;